import React, { useCallback } from 'react';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { queryCache, useMutation, useQuery } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { useEnsureContext } from 'common/hooks';
import { useParams } from 'react-router';
import { message, Skeleton } from 'antd';
import { ProfileOwnerForm } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerProfileOwnerPage/BusinessPartnerUserForm';
import { ProfileOwnerFormModel } from 'models/user';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SaveButton } from 'common/components/SaveButton';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const BusinessPartnerUserPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const { partnerProfileOwnerId } = useParams<{
    partnerProfileOwnerId: string;
  }>();

  const { isLoading, data } = useQuery(
    [QueryKey.BusinessPartnerDoctor, bpContext.id, partnerProfileOwnerId],
    () => {
      return BusinessPartnersAPI.fetchProfileOwnerById(
        bpContext.id,
        Number(partnerProfileOwnerId)
      );
    }
  );

  const [mutate, mutationHelpers] = useMutation(
    BusinessPartnersAPI.modifyProfileOwnerById
  );

  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<ProfileOwnerFormModel> = useCallback(
    (formData) => {
      mutate(
        { businessPartnerId: bpContext.id, dto: formData },
        {
          onSuccess: () => {
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerProfileOwnersList)
              .then();
            message.success(
              intlMessage(
                { id: 'entity.updated' },
                {
                  name: `${formData.firstName} ${formData.lastName}`,
                }
              )
            );
          },
        }
      ).then();
    },
    [bpContext, mutate, intlMessage]
  );

  return (
    <>
      {isLoading && <Skeleton />}
      {!isLoading && data && (
        <ProfileOwnerForm onSubmit={handleSubmit} initialValues={data}>
          <SaveButton loading={mutationHelpers.isLoading} />
        </ProfileOwnerForm>
      )}
    </>
  );
};
